'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { FieldSetContext } from '../field-set/context/field-set.context';
import { FormFieldContext } from '../form-field/context/form-field.context';
import { legendRecipe } from './styles/legend.styles';
import type { LegendPropsInterface } from './types/legend.types';

export const Legend = forwardRef<HTMLLegendElement, LegendPropsInterface>(
  (props: LegendPropsInterface, forwardedRef) => {
    const fieldSetContext = useContext(FieldSetContext);
    const formFieldContext = useContext(FormFieldContext);

    const {
      className,
      css: cssProp,
      disabled = formFieldContext.disabled || false,
      required = formFieldContext.required || false,
      requiredText = formFieldContext.requiredText ?? 'asterisk',
      optional = formFieldContext.optional || false,
      size = fieldSetContext.size || 'md',
      ...rest
    } = props;

    const styles = css(
      legendRecipe.raw({
        size,
        disabled,
        requiredText: required ? requiredText : undefined,
        optional,
      }),
      cssProp,
    );

    return (
      <legend
        aria-disabled={disabled || undefined}
        ref={forwardedRef}
        className={cx('c11n', 'c11n_legend', styles, className)}
        data-c11n-component="Legend"
        data-c11n-version={__C11N_VERSION__}
        {...rest}
      />
    );
  },
);

Legend.displayName = 'Legend';
